export default __webpack_public_path__ + "static/media/iproprium.e8f813c2.png";